export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11250.55bad700.jpg";